import { render, staticRenderFns } from "./ProjectOptionItem.vue?vue&type=template&id=4ced6208&scoped=true&"
import script from "./ProjectOptionItem.vue?vue&type=script&lang=js&"
export * from "./ProjectOptionItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOptionItem.vue?vue&type=style&index=0&id=4ced6208&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced6208",
  null
  
)

export default component.exports